import { useProFormaSocketContext } from '../socketContext/ProFormaSocketProvider';
import CalculatingProgressBar from './CalculatingProgressBar';

const ProFormaCalculatingProgressBar = () => {
    const { isCalculating } = useProFormaSocketContext();

    if (!isCalculating) {
        return null;
    }

    return <CalculatingProgressBar />;
};

export default ProFormaCalculatingProgressBar;
